import { Box, Step, StepLabel, Stepper } from "@mui/material";
import React, { useEffect, useState } from "react";
import LeftSidebar from "../partials/leftSidebar";
import Header from "../partials/header";
import OrderCreateStep1SiteDevice from "./orderCreateSteps/OrderCreateStep1SiteDevice";
import OrderCreateStep2Feature from "./orderCreateSteps/OrderCreateStep2Feature";
import OrderCreateStep3Confirm from "./orderCreateSteps/OrderCreateStep3Confirm";
import { getUserPriority } from "../../services/authService";
import { PROFILE_TYPE } from "../../helper/globalConstant";

export default function OrderCreate() {
  const [activeStep, setActiveStep] = useState(0);
  const [customerInfo, setCustomerInfo] = useState();
  const [siteInfo, setSiteInfo] = useState();
  const [orderInfo, setOrderInfo] = useState();
  const [selectedFeatureList, setSelectedFeatureList] = useState([]);
  const [globalFeatureList, setGlobalFeatureList] = useState([]);

  const [filteredStateList, setFilteredStateList] = useState([]);
  const [filteredCityList, setFilteredCityList] = useState([]);
  const [siteType, setSiteType] = useState("1");
  const [step1FormValues, setStep1FormValues] = useState();
  const [step2FormValues, setStep2FormValues] = useState();
  const [customerWiseSiteList, setCustomerWiseSiteList] = useState([]);
  const [userPriority, setUserPriority] = useState<number | undefined>(getUserPriority());

  useEffect(() => {
    const priority = getUserPriority();
    setUserPriority(priority);
  }, []);

  const steps = userPriority === PROFILE_TYPE.DISTRIBUTOR 
    ? ["Partner", "Feature", "Confirm Order"] 
    : ["Site / Device", "Feature", "Confirm Order"];

  const pageTitle = userPriority === PROFILE_TYPE.DISTRIBUTOR 
    ? "Add New Partner Order" 
    : "Add New Site Order";

  useEffect(() => {
    console.log("///////// siteInfo change /////////", siteInfo);
  }, [siteInfo]);

  useEffect(() => {
    console.log("///////// step1FormValues /////////", step1FormValues);
  }, [step1FormValues]);

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <Header title={pageTitle} />
        <LeftSidebar />

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            marginTop: 14,
            padding: "0",
          }}
        >
          <Box
            p={3}
            sx={{
              backgroundColor: "#03171F",
              color: "#ffffff",
              minHeight: "calc(100vh - 135px)",
            }}
          >
            <Box
              sx={{
                display: "flex",
                width: "100",
              }}
            >
              <Stepper
                activeStep={activeStep}
                alternativeLabel
                sx={{ width: "100%" }}
              >
                {steps.map((label, index) => (
                  <Step key={index}>
                    <StepLabel className="stapeLabel">{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Box>

            {activeStep === 0 && (
              <Box mt={5}>
                <OrderCreateStep1SiteDevice
                  setSiteType={setSiteType}
                  siteType={siteType}
                  setStep1FormValues={setStep1FormValues}
                  step1FormValues={step1FormValues}
                  setActiveStep={setActiveStep}
                  customerInfo={customerInfo}
                  siteInfo={siteInfo}
                  setSiteInfo={setSiteInfo}
                  setOrderInfo={setOrderInfo}
                  orderInfo={orderInfo}
                  setCustomerWiseSiteList={setCustomerWiseSiteList}
                  customerWiseSiteList={customerWiseSiteList}
                  setFilteredStateList={setFilteredStateList}
                  filteredStateList={filteredStateList}
                  setFilteredCityList={setFilteredCityList}
                  filteredCityList={filteredCityList}
                />
              </Box>
            )}

            {activeStep === 1 && (
              <Box mt={5}>
                <OrderCreateStep2Feature
                  setActiveStep={setActiveStep}
                  customerInfo={customerInfo}
                  siteInfo={siteInfo}
                  setOrderInfo={setOrderInfo}
                  orderInfo={orderInfo}
                  setSelectedFeatureList={setSelectedFeatureList}
                  selectedFeatureList={selectedFeatureList}
                  setGlobalFeatureList={setGlobalFeatureList}
                />
              </Box>
            )}

            {activeStep === 2 && (
              <Box mt={5}>
                <OrderCreateStep3Confirm
                  customerInfo={customerInfo}
                  siteInfo={siteInfo}
                  setOrderInfo={setOrderInfo}
                  orderInfo={orderInfo}
                  globalFeatureList={globalFeatureList}
                  selectedFeatureList={selectedFeatureList}
                />
              </Box>
            )}

            {/* {activeStep === 3 &&
							<Box mt={5}>
                                3
							</Box>
						} */}
          </Box>
        </Box>
      </Box>
    </>
  );
}
